export const SUGGESTED_OBJECTS = [
  {norad_id:25544,name:'International Space Station',category:'station',aliases:['iss','zarya','international space station']},
  {norad_id:48274,name:'Tiangong Space Station',category:'station',aliases:['tiangong','css','tianhe']},
  {norad_id:20580,name:'Hubble Space Telescope',category:'science',aliases:['hubble','hst']},
  {norad_id:50463,name:'James Webb Space Telescope',category:'science',aliases:['james webb','jwst','webb']},
];
export function rankCatalog(query, catalog=[]) {
  const q=query.trim().toLowerCase();
  const suggested=SUGGESTED_OBJECTS.filter(s=>String(s.norad_id)===q||[s.name,...s.aliases].some(n=>n.toLowerCase().includes(q)));
  const merged=new Map();
  for(const sat of [...suggested,...catalog])merged.set(Number(sat.norad_id),{...merged.get(Number(sat.norad_id)),...sat});
  function score(s) {
    if(String(s.norad_id)===q)return 100;
    const name=s.name.toLowerCase();
    if(name===q||s.aliases?.includes(q))return 90;
    if(name.startsWith(q))return 50;
    return 10;
  }
  return [...merged.values()].sort((a,b)=>score(b)-score(a)||(a.category==='station'?-1:0)-(b.category==='station'?-1:0)||a.name.localeCompare(b.name)).slice(0,20);
}
